export const MEDIA_QUERY = {
        PHONE: 'min-width: 400px',
        TABLET: 'min-width: 600px',
        SMALL_DESKTOP: 'min-width: 1024px',
        DESKTOP: 'min-width: 1250px',
}